import Cropper from "cropperjs";
window.Cropper = Cropper;
/*!
 * jQuery Cropper v1.0.2
 * https://fengyuanchen.github.io/jquery-cropper
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2025-03-08T08:35:16.178Z
 */

export default Cropper

const oldFunc = window.Cropper.prototype.getCroppedCanvas;
window.Cropper.prototype.getCroppedCanvas = function (...args) {
	const oldFloorFunc = Math.floor;
	let count = 0;
	Math.floor = function (num) {
		return count++ < 2 ? num : oldFloorFunc.apply(this, arguments);
	};

	const res = oldFunc.apply(this, args);

	Math.floor = oldFloorFunc;

	return res;
};
